import { authorizedFetch, baseUrl, removeEmpty } from './base';
import queryString from 'query-string';

async function accounts(params = {}) {
  const path = `${baseUrl}/console/api/super_admin/statistics?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function order_payments(params = {}) {
  const path = `${baseUrl}/console/api/super_admin/statistics/order_payments?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function messages(params = {}) {
  const path = `${baseUrl}/console/api/super_admin/statistics/messages?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function tenant_details(tenant_id, params = {}) {
  const path = `${baseUrl}/console/api/super_admin/statistics/${tenant_id}?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

const statisticApis = { accounts, order_payments, messages, tenant_details };

export default statisticApis;
